/**
 * Dirección que no lleva a ninguna parte.
 *
 * Usa el mismo armazón que las páginas de destino y no el de la página de
 * venta: a esto se llega casi siempre desde un código mal escaneado o un
 * enlace roto, o sea, con el móvil en la mano y sin saber qué ha pasado.
 */
export function NotFound() {
  return (
    <main className="destino">
      <div className="destino__lienzo">
        <div className="destino__aviso">
          <h1>Aquí no hay nada</h1>
          <p>
            El enlace que has seguido no lleva a ninguna parte. Si venías de un código
            QR, puede que se escaneara mal: inténtalo otra vez.
          </p>
        </div>
        <div className="destino__zocalo">
          <a className="destino__accion" href="/">
            Ir al inicio
          </a>
        </div>
      </div>
    </main>
  );
}
